<template>
 <div>
     <div v-if="notCode == true"  class="not_list">
        <img src="../assets/images/face.png" alt="">
        <p>暂无数据呢!</p>
    </div>
 </div>
</template>
<script>
export default {
   props:['notCode']
}
</script>
<style scoped>
.not_list{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px auto;
}
.not_list p{
    margin-left: 15px;
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/common/notList.vue